import { render, staticRenderFns } from "./chatComponent.vue?vue&type=template&id=102f2bb1&scoped=true"
import script from "./chatComponent.vue?vue&type=script&lang=js"
export * from "./chatComponent.vue?vue&type=script&lang=js"
import style0 from "./chatComponent.vue?vue&type=style&index=0&id=102f2bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f2bb1",
  null
  
)

export default component.exports